import SimpleCheckbox from "@/app/components/ui/CheckBoxes/SimpleCheckbox";
import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment, useRef, useState } from "react";
import { PiWarningFill } from "react-icons/pi";
type Props = {
  open: boolean;
  setOpen: (value: boolean) => void;
};

const DuplicateTabDetectionModal: React.FC<Props> = ({ open, setOpen }) => {
  const cancelButtonRef = useRef(null);
  const [checked, setchecked] = useState(false);

  return (
    <div>
      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-50 overflow-y-auto"
          initialFocus={cancelButtonRef}
          onClose={() => {
            // setOpen(false);
          }}
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" />
            </Transition.Child>

            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
              &#8203;
            </span>

            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div className="inline-block align-bottom bg-white rounded-2xl text-left  overflow-visible  shadow-xl transform transition-all sm:my-8 sm:align-middle sm:w-full sm:max-w-xl">
                <div className="bg-white px-4  pb-4 sm:p-8 sm:pb-4 rounded-2xl">
                  <div className="flex flex-col pb-4">
                    <div className="flex justify-center py-3">
                      <PiWarningFill className="w-6 h-6 fill-red-500" />
                    </div>
                    <h2 className="text-base font-semibold text-red-500 text-center">
                      {" "}
                      This EMR is already open for editing in another tab. Please close this tab and continue editing in
                      the original tab to avoid data conflicts.
                    </h2>
                  </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
};

export default DuplicateTabDetectionModal;
